
import { IAuthRepositoryCB } from "../interfaces/repository/IAuthRepository";
import { api } from "services/api/Api";

export const RemoveAuthUseCase = (_authRepository: IAuthRepositoryCB) => {
    const authLocalRepository = _authRepository();
    api.defaults.headers.Authorization = undefined;
    authLocalRepository.remove();
}
